import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ContentType } from '../../models/enums/content-type.enum';
import { CourseContent } from '../../models/interfaces/content.interface';
import { getCrudErrors } from '../../utils/functions';
import { Api } from '../api/api';
import { contentMock } from '../../mocks/interfaces/content.mock';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  private readonly api: Api = new Api();

  private contents: CourseContent[] = structuredClone(contentMock);

  //#region Real API

  public async getById(contentId: string): Promise<CourseContent | undefined> {
    if (environment.useFakeBackend) {
      return this.getByIdMocked(contentId);
    }

    const { error, success } = await this.api.getAsync<CourseContent>(environment.routes.contents.one(contentId));

    if (!success)
      throw new Error(getCrudErrors(error)[0]);

    return success;
  }

  public async getActivityById(contentId: string): Promise<CourseContent | undefined> {
    if (environment.useFakeBackend) {
      return this.getActivityByIdMocked(contentId);
    }

    const content = await this.getById(contentId);

    return content?.type === ContentType.ACTIVITY ? content : undefined;
  }

  //#endregion

  //#region Fake Backend

  public async getByIdMocked(contentId: string): Promise<CourseContent | undefined> {
    return this.contents.find(content => content.id === contentId);
  }

  public async getActivityByIdMocked(contentId: string): Promise<CourseContent | undefined> {
    const content = await this.getByIdMocked(contentId);

    return content?.type === ContentType.ACTIVITY ? content : undefined;
  }

  public resetMockData(): void {
    this.contents = structuredClone(contentMock);
  }

  //#endregion

}
